export const footer = () => {
	const button = document.querySelector('.js-footer-scrollto');
	const footer = document.querySelector('.footer-main');
	if (!button || !footer) return;

	const tabletMQ = window.matchMedia(`(min-width: ${vars.breakpoint.tablet}px)`);
	const topOffset = tabletMQ.matches ? 1000 : 500;
	let isFooterVisible = false;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			isFooterVisible = entry.isIntersecting;
			updateButton();
		});
	});
	observer.observe(footer);

	window.addEventListener('scroll', updateButton, { passive: true });

	function updateButton() {
		if (!isFooterVisible && window.scrollY > topOffset) {
			button.classList.add('footer-scrollto--is-floating');
		} else {
			button.classList.remove('footer-scrollto--is-floating');
		}
	}
};
